import React from "react";
import { getLocalString, localNames } from "utils/localisation.service";
import { useSelector } from 'react-redux';

function renderSwitch(param, locales) {
    switch (param) {
        case 'Σε Επεξεργασία':
            return <div className="application-badge process-badge"><span>'Σε Επεξεργασία'</span></div>;
        case 'Υποβολή Αίτησης':
            return <div className="application-badge start-badge"><span>{getLocalString(locales, localNames.TASK_NAME_SUBMITAPPLICATION)}</span></div>;
        case 'Αξιολόγηση':
            return <div className="application-badge edit-badge"><span>{getLocalString(locales, localNames.TASK_NAME_AUDITAPPLICATION)}</span></div>;
        case 'Δημιουργία Κουπονιού':
            return <div className="application-badge completion-badge"><span>{getLocalString(locales, localNames.TASK_NAME_CREATEVOUCHER)}</span></div>;
        case 'Απένταξη Αίτησης':
            return <div className="application-badge evaluate-badge"><span>{getLocalString(locales, localNames.TASK_NAME_AUDITREJECTION)}</span></div>;
        //Υποβολή Αίτησης
        case 'task.name.submit_application':
            return <div className="application-badge start-badge"><span>{getLocalString(locales, localNames.TASK_NAME_SUBMITAPPLICATION)}</span></div>; 
        //Αξιολόγηση Αίτησης (ΚτΠ)
        case 'task.name.audit_application':
            return <div className="application-badge edit-badge"><span>{getLocalString(locales, localNames.TASK_NAME_AUDITAPPLICATION)}</span></div>; 
        //Δημιουργία Κουπονιού
        case 'task.name.create_voucher':
            return <div className="application-badge completion-badge"><span>{getLocalString(locales, localNames.TASK_NAME_CREATEVOUCHER)}</span></div>; 
        //Απένταξη Αίτησης (απόρριψη από ΚτΠ)
        case 'task.name.audit_rejection':
            return <div className="application-badge evaluate-badge"><span>{getLocalString(locales, localNames.TASK_NAME_AUDITREJECTION)}</span></div>;
        //Ακύρωση Αίτησης (ακύρωση από Ωφελούμενο)
        case 'task.name.cancel_application':
            return <div className="application-badge evaluate-badge"><span>{getLocalString(locales, localNames.TASK_NAME_CANCELAPPLICATION)}</span></div>; 
        //Υλοποίηση Προγράμματος - Δεσμέυτηκε Κουπόνι (voucher reserved από Πάροχο)
        case 'task.name.program_implementation':
            return <div className="application-badge program-badge"><span>{getLocalString(locales, localNames.TASK_NAME_PROGRAMIMPLEMENTATION)}</span></div>;
        //Υλοποίηση Προγράμματος - Υποβλήθηκε Δήλωση Ενεργοποίησης (voucher redeemed από Πάροχο)
        case 'task.name.program_implementation_complete':
            return <div className="application-badge program-badge"><span>{getLocalString(locales, localNames.TASK_NAME_PROGRAMIMPLEMENTATION_COMPLETE)}</span></div>;
        //Ολοκλήρωση – Χωρίς Αποδοχή Ωφελούμενου (πέρας 5 ημερών χωρίς ενέργεια)
        case 'task.name.complete_application_without_approval':
            return <div className="application-badge program-badge"><span>{getLocalString(locales, localNames.TASK_NAME_PROGRAMIMPLEMENTATION_COMPLETEWITHOUTAPPROVAL)}</span></div>;
        //Ολοκλήρωση – Με Αποδοχή Ωφελούμενου (έγκριση από Ωφελούμενο)
        case 'task.name.complete_application_with_approval':
            return <div className="application-badge program-badge"><span>{getLocalString(locales, localNames.TASK_NAME_PROGRAMIMPLEMENTATION_COMPLETEWITHAPPROVAL)}</span></div>;
        //Υποβολή Ένστασης - Υποβλήθηκαν Αντιρρήσεις από Ωφελούμενο (απόρριψη από Ωφελούμενο)
        case 'task.name.sumbit_objection':
            return <div className="application-badge program-badge"><span>{getLocalString(locales, localNames.TASK_NAME_OBJECTION_SUMBIT)}</span></div>;
        //Υποβολή Ένστασης - Αξιολόγηση από Πάροχο / Διορθωτικές ενέργειες (απάντηση από Πάροχο)
        case 'task.name.audit_objection':
            return <div className="application-badge program-badge"><span>{getLocalString(locales, localNames.TASK_NAME_OBJECTION_AUDIT)}</span></div>;
        //more statuses placeholders for the future
        case 'task.name.voucher_cancel':
            return <div className="application-badge start-badge"><span>{getLocalString(locales, localNames.TASK_NAME_CANCEL_VOUCHER)}</span></div>;
        case 'task.name.complete_application_request':
            return <div className="application-badge start-badge"><span>{getLocalString(locales, localNames.TASK_NAME_COMPLETE_REQUEST)}</span></div>;
        case 'task.name.complete_application_for_payment':
            return <div className="application-badge start-badge"><span>{getLocalString(locales, localNames.TASK_NAME_COMPLETE_TOPAY)}</span></div>;
        case 'task.name.reject_payment':
            return <div className="application-badge start-badge"><span>{getLocalString(locales, localNames.TASK_NAME_PAYMENT_REJECT)}</span></div>;
        case 'task.name.accept_payment':     
        return <div className="application-badge start-badge"><span>{getLocalString(locales, localNames.TASK_NAME_PAYMENT_APPROVE)}</span></div>;
        case 'Βαγγέλης':
            return <div className="application-badge start-badge"><span>{'Μια χαρααααά'}</span></div>; 
        default:
            return null;
    }
}

const StatusTag = (props) => {
    const locales = useSelector(state => state.forms?.localeStrings);
    return renderSwitch(props.status, locales);
}

export default StatusTag;